<template>
    <div>
        <vForm class="clearfix" style="padding-top: 20px;" ref="dataForm" labelWidth="100" v-model="formData">
            <vCol span="12">
                <vFormItem :label="$t('fbb.headlogistics.declare_date', { defaultValue: '报关日期' })" prop="extra_declare_date" :rules="required">
                    <vDatepicker type="date" v-model="formData.extra_declare_date"></vDatepicker>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem :label="$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' })">
                    <!-- <vSelect v-model="formData.transport_type" disabled>
                        <vOption v-for="item in transportList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect> -->
                    <div class="font-weight">{{transportType}}</div>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem :label="$t('fbb.headlogistics.actual_loading_date', { defaultValue: '实际装柜日期' })" prop="actual_loading_date" :rules="required">
                    <vDatepicker v-model="formData.actual_loading_date" type="date" :confirm="false"></vDatepicker>
                </vFormItem>
            </vCol>
            <div v-if="formData.transport_type === 0">
                <div v-for="item in formData.inbounds" :key="item.key">
                    <vCol span="24">
                        <div class="font-weight" style="padding-left: 20px; height: 42px;">{{$t('fbb.headlogistics.inbound', { defaultValue: '入库单' })}} {{item.id}}</div>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.20gp_number', { defaultValue: '20GP数量' })" labelWidth="100">
                            <vInputNumber min="1" v-model="item.data['extra_cabinet_20GP_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.20gp_container_number', { defaultValue: '20GP集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_20GP_no']"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.40gp_number', { defaultValue: '40GP数量' })" labelWidth="100">
                            <vInputNumber min="1" v-model="item.data['extra_cabinet_40GP_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.40gp_container_number', { defaultValue: '40GP集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_40GP_no']"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.40hq_number', { defaultValue: '40HQ数量' })" labelWidth="100">
                            <vInputNumber min="1" v-model="item.data['extra_cabinet_40HQ_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.40hq_container_number', { defaultValue: '40HQ集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_40HQ_no']"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.45hq_number', { defaultValue: '45HQ数量' })" labelWidth="100">
                            <vInputNumber min="1" v-model="item.data['extra_cabinet_45HQ_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem :label="$t('fbb.headlogistics.45hq_container_number', { defaultValue: '45HQ集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_45HQ_no']"></vInput>
                        </vFormItem>
                    </vCol>
                </div>
            </div>
            <div v-else class="clearfix">
                <vCol span="12" class="clearfix">
                    <vFormItem class="pull-left width-100per" :label="$t('fbb.headlogistics.total_volumn', { defaultValue: '总体积' }) + '(CBM)'" labelWidth="100" prop="total_vol" :rules="required">
                        <vInputNumber min="0" v-model="formData.total_vol"></vInputNumber>
                    </vFormItem>
                </vCol>
            </div>
        </vForm>
    </div>
</template>

<script>
import mixinList from '../mixin'
import comExam from "./comExam";
import comBookingSpace from "./comBookingSpace";
export default {
    mixins: [mixinList],
    components: {
        compUpload: () => import("@components/templates/upload"),
        comExam,
        comBookingSpace,
    },
    props: ["componentName", "originData", "type"],
    created() {
        let tItem = this.gettransportType.filter(item => {
            return item.value === this.originData.transportType
        })[0]
        // this.transportType = tItem.value
        // this.transportType = 0
        this.transportType = tItem.label
        this.formData.transport_type = tItem.value
        this.getChildOrder()
    },
    data() {
        return {
            formData: {
                transport_type: 0,
                inbounds: []
            },
            required: [
                {
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
                }
            ]
        };
    },
    methods: {
        getChildOrder () {
            this.formData.inbounds = this.originData.subLogisticsHeadParams.map(item => {
                return {
                    id: item.orderNo,
                    data: {}
                }
            })
        },
        async checkForm () {
            let flag = true
            await this.$refs.dataForm.validate(valid => {
                if (!valid) flag = false
            })
            if (this.formData.transport_type === 0) {
                flag = this.validInbounds(this.formData.inbounds)
            }
            // 去掉集装箱信息
            else {
                this.formData.inbounds = []
            }
            return flag
        }
    }
};
</script>

<style scropd>
.font-weight {
    font-weight: bold;
}
</style>
